import { owaComputedFn } from "owa-computed-fn";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import type { MailboxInfo } from "owa-client-types";
import { getMailboxInfoForGroup } from "owa-mailbox-info/lib/getMailboxInfoForGroup";

export const getGroupsPanelMailboxInfo: (groupId: string) => MailboxInfo = owaComputedFn((groupId: string): MailboxInfo => {
    return getMailboxInfoForGroup(getModuleContextMailboxInfo(), groupId);
});
